import React from 'react';
import { Table, TableBody } from '@insurancemenu/imenu-components-lib';
import { DDARCustomUser } from 'types/formService';
import { createStyles } from './styles';
import UsersTableRow from '../UsersTableRow';

interface Props {
  users: DDARCustomUser[];
  onEditUser: (tier: DDARCustomUser) => void;
  onDeleteUser: (id: number) => void;
}

const UsersTable: React.FC<Props> = ({ users, onEditUser, onDeleteUser }) => {
  const classes = createStyles();
  return (
    <Table totalElements={users.length} minHeight="auto">
      <TableBody className={classes.tableBody}>
        {users.map((user) => (
          <UsersTableRow key={user.id} user={user} onEdit={onEditUser} onDelete={onDeleteUser} />
        ))}
      </TableBody>
    </Table>
  );
};

export default UsersTable;
